import { CustomPageType } from '../custom-pages/cp-enum';
import { SLIDER_OPTIONS } from '../se-toolbar/se-buttons-toolbar/redux/se-buttons-toolbar.state';
import { ToolbarSliderOptions } from '../se-toolbar/se-buttons-toolbar/types';
import { BaseExamination } from './vnext.models';

export interface ICpMinimalExamination {
    idCustomPage: string;
    idCustomPageRoot: string;
    idModelTypeRoots: string[];
    idModelType?: string[];
}

export interface CpExamination extends BaseExamination, ICpMinimalExamination {
}

export interface CpRouterExaminationData {
    id: string;
    idCustomPage: string | null;
    idCustomPageRoots: string[];
    idModelTypeRoots: string[];
    idReport: string | null;
}

export interface CpRouterData {
    examinations: CpRouterExaminationData[];
    idCustomPageRoot: string;
}

export class CustomPageConfig {
    type: CustomPageType;
    isBackVisible: boolean;
    leftSliderConfig: ToolbarSliderOptions;
    rightSliderConfig: ToolbarSliderOptions;

    constructor(
        cpType: CustomPageType,
        isBackVisible?: boolean,
        leftSliderConfig?: ToolbarSliderOptions,
        rightSliderConfig?: ToolbarSliderOptions,
    ) {
        this.type = cpType;
        this.isBackVisible = isBackVisible ? isBackVisible : false;
        this.leftSliderConfig = leftSliderConfig ? leftSliderConfig : SLIDER_OPTIONS.LEFT_SLIDER_OPEN;
        this.rightSliderConfig = rightSliderConfig ? rightSliderConfig : SLIDER_OPTIONS.RIGHT_SLIDER_CLOSED;
    }
}

